import is from '@sindresorhus/is';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';

export type StandaloneProfileItemType = 'job-level' | 'job-role';

export type NavigateToStandaloneProfileParams = {
    readonly architectureId: string;
    readonly itemId: string;
    readonly itemType: StandaloneProfileItemType;
    readonly preferredLanguage?: string;
};

type UseNavigateToStandaloneProfileReturn = {
    readonly getStandalonePath: (architectureId: string, itemId: string, itemType: StandaloneProfileItemType) => string;
    readonly navigate: (params: NavigateToStandaloneProfileParams) => void;
};

const getStandalonePath = (architectureId: string, itemId: string, itemType: StandaloneProfileItemType): string => {
    return `/job-profile/${architectureId}/${itemType}/${itemId}`;
};

export const useNavigateToStandaloneProfile = (): UseNavigateToStandaloneProfileReturn => {
    const routerNavigate = useNavigate();

    const navigate = useCallback(
        ({ architectureId, itemId, itemType, preferredLanguage }: NavigateToStandaloneProfileParams): void => {
            const baseUrl = getStandalonePath(architectureId, itemId, itemType);
            const currentPath = window.location.pathname + window.location.search;

            const url = new URL(baseUrl, window.location.origin);
            url.searchParams.set('returnUrl', currentPath);
            if (is.nonEmptyString(preferredLanguage)) {
                url.searchParams.set('preferredLanguage', preferredLanguage);
            }

            routerNavigate(url.pathname + url.search);
        },
        [routerNavigate],
    );

    return { getStandalonePath, navigate };
};
